<template>
  <div :data-testid="dataTestid">
    <div :data-testid="`${dataTestid}-row`" class="flex items-center gap-2">
      <span v-if="$slots.icon" :data-testid="`${dataTestid}-icon`" class="flex shrink-0 text-icon-main" aria-hidden="true">
        <slot name="icon" />
      </span>
      <span :data-testid="`${dataTestid}-value`" :class="valueClass">{{ value }}</span>
      <InsightsTrendBadge v-if="trend" :value="trend.value" :direction="trend.direction" :data-testid="`${dataTestid}-trend`" />
    </div>
    <p :data-testid="`${dataTestid}-caption`" class="mt-2 txt-body-s-regular text-subtle">{{ caption }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import InsightsTrendBadge from './InsightsTrendBadge.vue'
import type { InsightsTrendDirection } from './InsightsTrendBadge.vue'

const props = withDefaults(
  defineProps<{
    value: string
    caption: string
    trend?: { value: string; direction: InsightsTrendDirection }
    size?: 'l' | 'm'
    dataTestid?: string
  }>(),
  { trend: undefined, size: 'l', dataTestid: 'insights-hero-metric' },
)

const valueClass = computed(() => [props.size === 'm' ? 'txt-headline-xl-bold' : 'txt-headline-2xl-bold', 'text-main'])
</script>
